export default "__VITE_ASSET__tOM2kYnU__"